<template>
  <div ref="container">
    <transition name="zoom">
      <div class="nd-dialog" @click.self="outsideClickHandler" v-show="visible" :style="{ 'z-index': zIndex }">
        <div class="nd-dialog-content">
          <div v-show="closeBtn" class="close" @click="closeHandler"><img src="./images/btn_close.png"></div>
          <slot name="custom">
            <div :class="['default-content',{'bg-trans':isShowBg}]">
              <div class="dialog-title" v-if="title">
                <slot name="title">
                  {{ title }}
                </slot>
              </div>
              <slot></slot>
              <div class="dialog-footer" v-if="footer">
                <slot name="footer">
                  <nd-button class="btn line small" @click="cancelHandler">{{ cancelText }}</nd-button>
                  <nd-button class="btn small" @click="$emit('confirm')">{{ confirmText }}</nd-button>
                </slot>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import popupManager from '../nd-popup-manager'
let top
export default {
  name: 'index',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: true
    },
    closeBtn: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    easyToClose: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    isShowBg: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    if (this.mask) {
      this.maskInstance = this.$mask('', this.$refs['container'])
    }
    this.zIndex = popupManager.generateIndex()
  },

  destroyed () {
    if (this.mask) {
      this.maskInstance.remove()
    }
  },

  data () {
    return {
      visible: this.value,
      zIndex: 1000,
      maskInstance: null
    }
  },

  watch: {
    value: {
      deep: true,
      handler (value) {
        this.visible = value
        this.setCurrentValue(value)
        if (!this.mask) return
        if (this.value) {
          this.maskInstance.open()
        } else {
          this.maskInstance.hide()
        }
      }
    },

    visible: {
      deep: true,
      immediate: true,
      handler: value => {
        if (value) {
          top = document.body.scrollTop
          document.body.style.overflow = 'hidden'
        } else {
          document.body.scrollTop = top
          document.body.style.overflow = 'scroll'
        }
      }
    }
  },

  methods: {
    close () {
      this.visible = false
      this.setCurrentValue(false)
    },

    outsideClickHandler () {
      this.easyToClose && this.closeHandler()
    },

    closeHandler (e) {
      this.$emit('close', e)
      this.close()
    },

    cancelHandler (e) {
      this.$emit('cancel')
      this.closeHandler(e)
    },

    setCurrentValue (value) {
      if (value === this.value) return
      this.$emit('input', value)
    }
  },
  beforeDestroy () {
    document.body.style.overflow = 'scroll'
  }
        
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

    .zoomIn {
        animation: zoomIn .3s ease;
    }

    .zoomOut {
        animation: zoomOut .3s ease;
    }

    .zoom-enter-active {
        .zoomIn
    }

    .zoom-leave-active {
        .zoomOut
    }
    .bg-trans{
        background:transparent !important;
        padding-top:0 !important;
    }
    .nd-dialog {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;
        
        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border: none;
        }

        .nd-dialog-content {
            position: relative;

            .close {
                position: absolute;
                width: 56px;
                height: 56px;
                right: 22px;
                top: -78px;
                border-radius: 50%;
                overflow: hidden;
            }
        }

        .default-content {
            width: 620px;
            border-radius: 30px;
            padding-top: 40px;
            background: white;
            overflow: hidden;

            .dialog-title {
                text-align: center;
                font-size: 36px;
                padding-bottom: 15px;
                font-weight: 600;
            }

            .dialog-footer {
                padding: 0 50px;
                padding-bottom: 40px;
                display: flex;
                justify-content: space-between;
                background-color: #FFFFFF;

                .btn {
                    width: 240px;
                    height: 80px;
                    line-height: 80px;
                }
            }
        }
    }
</style>
